module.exports = __webpack_public_path__ + "img/logo-dinamo-HSM.60ba9c13.svg";